import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FxContext = createContext(null);

const NO_DECIMALS = ['COP', 'CLP', 'ARS'];

export const FxProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [currency, setCurrencyState] = useState(localStorage.getItem('vbx_currency') || null);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/fx/context`)
      .then((res) => {
        if (!mounted) return;
        setData(res.data);
        if (!localStorage.getItem('vbx_currency')) {
          setCurrencyState(res.data.currency || 'MXN');
        }
      })
      .catch(() => { if (mounted) setData({ rates: { MXN: 1 }, symbols: { MXN: '$' }, supported: ['MXN'], currency: 'MXN' }); });
    return () => { mounted = false; };
  }, []);

  const setCurrency = useCallback((c) => {
    setCurrencyState(c);
    localStorage.setItem('vbx_currency', c);
  }, []);

  const cur = currency || data?.currency || 'MXN';

  const formatRef = useCallback((mxnAmount) => {
    if (!data || !data.rates || cur === 'MXN' || !data.rates[cur]) return null;
    const value = mxnAmount * data.rates[cur];
    const decimals = NO_DECIMALS.includes(cur) ? 0 : 2;
    const num = new Intl.NumberFormat('es-MX', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value);
    return `${data.symbols[cur] || ''}${num}`;
  }, [data, cur]);

  return (
    <FxContext.Provider value={{
      currency: cur,
      setCurrency,
      supported: data?.supported || ['MXN'],
      symbols: data?.symbols || { MXN: '$' },
      rates: data?.rates || { MXN: 1 },
      detectedCountry: data?.country,
      formatRef,
    }}>
      {children}
    </FxContext.Provider>
  );
};

export const useFx = () => {
  const ctx = useContext(FxContext);
  return ctx || { currency: 'MXN', setCurrency: () => {}, supported: ['MXN'], symbols: { MXN: '$' }, rates: { MXN: 1 }, formatRef: () => null };
};
